import { trackingService as trackingServiceBase } from '@bluecodecom/tracking';

import { EventName, TrackingEvents } from './types';

class TrackingService {
  private static instance: TrackingService;

  public static getInstance() {
    if (!TrackingService.instance) {
      TrackingService.instance = new TrackingService();
    }

    return TrackingService.instance;
  }

  public init(userId?: string) {
    trackingServiceBase.init(
      process.env['NX_PUBLIC_MIXPANEL_TOKEN'],
      userId,
      {},
      { app: 'sdk_feedback' },
    );
  }

  public trackEvent<T extends EventName>(
    event: T,
    ...params: TrackingEvents[T] extends null
      ? [undefined?]
      : [TrackingEvents[T]]
  ) {
    trackingServiceBase.trackEvent('SdkFeedback: ' + event, {
      ...params?.[0],
    });
  }
}

const trackingService = TrackingService.getInstance();

export default trackingService;
